import { bool, object } from 'yup';

export const AppointmentFollowedUpUpdateSchema = object().shape({
  followedUp: bool().required(),
});
